import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RuleManageListingComponent } from './components/rule-manage-listing/rule-manage-listing.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RuleConfigurationsComponent } from './components/rule-configurations/rule-configurations.component';
import { RuleConfigurationEditComponent } from './components/rule-configuration-edit/rule-configuration-edit.component';
import { RuleConfigurationDetailsComponent } from './components/rule-configuration-details/rule-configuration-details.component';
import { ClientRuleConfigListComponent } from './components/client-rule-config-list/client-rule-config-list.component';
import { CustomValidationComponent } from './components/custom-validation/custom-validation.component';

const routes: Routes = [
  { path: 'rule-management/list', component: RuleManageListingComponent},
  { path: 'subscriber-rule-config', component: RuleConfigurationsComponent},
  { path: 'system-rule-config', component: ClientRuleConfigListComponent},
  { path: 'custom-validation', component: CustomValidationComponent},

  { path: '**', redirectTo: 'rule-management/list' },
]

@NgModule({
  declarations: [
    RuleManageListingComponent,
    RuleConfigurationsComponent,
    RuleConfigurationEditComponent,
    RuleConfigurationDetailsComponent,
    ClientRuleConfigListComponent,
    CustomValidationComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ]
})
export class RuleConfigManageModule { }
